// import * as types from '../actions/actionTypes';
import initialValues from "../configurations/initialValues";

// IMPORTANT: Note that with Redux, state should NEVER be changed.
// State is considered immutable. Instead,
// create a copy of the state passed and set new values on the copy.
// Note that I'm using Object.assign to create a copy of current state
// and update values on the copy.
export default function user(state = initialValues.USER, action) {
  return state;
  /* switch (action.type) {
    default:
      return state;
  } */
}



// WEBPACK FOOTER //
// ./src/reducers/userReducer.js